import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.features.link-slack-user`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'User linked to Slack successfully.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to update user link. Please try again.',
  },
  reconnectErrorMessage: {
    id: `${scope}.reconnectErrorMessage`,
    defaultMessage:
      "Slack connection has expired. Please reconnect via the 'Add to Slack' button.",
  },
})
